import { render, staticRenderFns } from "./PersonalCenterMenu.vue?vue&type=template&id=88a51698&scoped=true"
import script from "./PersonalCenterMenu.vue?vue&type=script&lang=js"
export * from "./PersonalCenterMenu.vue?vue&type=script&lang=js"
import style0 from "./PersonalCenterMenu.vue?vue&type=style&index=0&id=88a51698&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a51698",
  null
  
)

export default component.exports